import { handleResponse } from './handleResponse';
import { displayError } from './displayError';
import { updateButton } from './updateButton';

/**
 * Adds a personalised product to the basket.
 * @param {HTMLButtonElement} button - The 'Add to basket' button event listener.
 * @param {number} productId - The ID of the product being added.
 * @param {string} productType - The ID of the product being added.
 * @param {number} quantity - The amount of product added
 */
export function addPersonalisedProductToBasket(
	button: HTMLButtonElement,
	productId: number,
	productType: string,
	quantity: number,
): void {
	void productType;

	// Collect basic product info
	const componentId = (document.getElementById('componentId') as HTMLInputElement)?.value || null;

	// Collect personalised data
	const recipientTitle =
		(document.getElementById('recipient_title') as HTMLInputElement)?.value || '';
	const recipientFirstName =
		(document.getElementById('recipient_first_name') as HTMLInputElement)?.value || '';
	const recipientLastName =
		(document.getElementById('recipient_last_name') as HTMLInputElement)?.value || '';
	const recipientEmail =
		(document.getElementById('recipient_email') as HTMLInputElement)?.value || '';
	const giftMessage = (document.getElementById('gift_message') as HTMLInputElement)?.value || '';

	// Package data into an object
	const data = {
		'productId': productId,
		'qty': quantity,
		'componentId': componentId,
		'mods[recipient_title]': recipientTitle,
		'mods[recipient_first_name]': recipientFirstName,
		'mods[recipient_last_name]': recipientLastName,
		'mods[recipient_email]': recipientEmail,
		'mods[gift_message]': giftMessage,
	};

	// Update the button to inform the user that their request is processing
	updateButton(button, true, false, null);

	// Send the data via Fetch API to the backend
	fetch(`/basket/ajaxAddPersonalised?${new URLSearchParams(data as any)}`, {
		method: 'GET', // Adjust to POST if needed
	})
		.then((response) => response.json())
		.then((jsonResponse) =>
			handleResponse(jsonResponse, productId, productType, quantity, button, null),
		)
		.catch(() => displayError('An error occurred while adding the product to the basket.'));
}
